import type { ProductCard } from '@hotmart/space-lib/dist/components/customCard/product/types'
import { TFunction } from 'i18next'
import { PaywallProductProps } from 'src/services/products/types'
import ProductDefaultImage from 'src/assets/svg/productDefaultImage.svg'

export class ProductUtils {
  static convertToProductCard(product: PaywallProductProps, t: TFunction): ProductCard {
    return {
      id: product.id,
      name: product.name,
      category: product.category ? t(`products.${product.category}`) : '',
      description: product.description,
      hotlink: product.hotlink ?? '',
      price: product.price ?? '',
      thumbnailImage: product.backgroundImageFinal ?? ProductDefaultImage,
      altText: product.altText ?? '',
      verticalCoverPage: product.verticalCoverPage ?? '',
      verticalAltText: product.verticalAltText ?? '',
      coverImage: product.coverPage ?? '',
      avatarAltText: product.avatarAltText ?? '',
      avatar: product.avatar ?? '',
      freeSignup: {
        isFreeSignup: product.freeSignup ?? false,
        text: '',
        color: ''
      }
    }
  }
}
